import React from 'react';
import { useTranslation } from 'react-i18next';

const BetaBadge = () => {
  const { t } = useTranslation();

  return (
    <span className="bg-blue-100 text-blue-600 text-xs uppercase font-medium p-1 rounded">
      {t('beta')}
    </span>
  );
};

export default BetaBadge;
